import { useThemeStore } from "@/stores/theme.store";
import { useNetworkCanvas } from "./useNetworkCanvas";

// Coluna esquerda: rede de nós animada (fiel ao import) + copy + chips.
export function LoginStage() {
  const isDark = useThemeStore((s) => s.isDark);
  const canvasRef = useNetworkCanvas(isDark);
  return (
    <div className="login-stage">
      <canvas ref={canvasRef} className="login-net" aria-hidden="true" />
      <div className="login-stage-copy">
        <h2>Cada máquina é um nó. Sua operação é a rede.</h2>
        <p>
          Conecte, simule e antecipe o comportamento da sua linha antes de mudar o chão de fábrica.
        </p>
        <div className="login-chips">
          <span className="login-chip">
            <span className="login-dot login-dot--brand" /> 128 ativos
          </span>
          <span className="login-chip">
            <span className="login-dot login-dot--accent" /> 34 linhas
          </span>
          <span className="login-chip">
            <span className="login-dot login-dot--ok" /> sincronizado
          </span>
        </div>
      </div>
    </div>
  );
}
